import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';
const Underline = _ref => {
  let {
    color = colors.neutral700,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 23.5c-4.965 0-9-4.035-9-9v-12h3.75v12c0 2.895 2.355 5.25 5.25 5.25s5.25-2.355 5.25-5.25v-12h3.75v12c0 4.965-4.035 9-9 9zM5.5 26.5h21v3h-21v-3z",
    fill: color
  }));
};
export default /*#__PURE__*/React.memo(Underline);